// extracted by mini-css-extract-plugin
export var auto = "_4g-1";
export var spinner = "_4g-0";